<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner-list">
    <div class="row mb-4">
      <div class="col-12">
        <div class="title-wrapper">
          <div>
            <h1 class="title-default">NFC-es em contingência</h1>
            <p class="welcome-message">Monitore suas notas fiscais emitidas em contingência.</p>
          </div>
        </div>
      </div>
    </div>

    <form [formGroup]="model" (ngSubmit)="clickPesquisar()">
      <div class="row search-area">
        <!-- Campo de Busca Rapida -->
        <div class="col-12 col-md-6">
          <mat-form-field appearance="outline">
            <mat-label>{{ pesquisaPlaceholderLabel }}</mat-label>
            <input
              matInput
              type="text"
              formControlName="pesquisa"
              [placeholder]="pesquisaPlaceholderInput"
              [attr.maxlength]="isPesquisaPorNumero ? 8 : 100"
              [attr.inputmode]="isPesquisaPorNumero ? 'numeric' : 'text'"
              [attr.pattern]="isPesquisaPorNumero ? '[0-9]*' : null"
              (input)="onPesquisaInput($any($event.target).value)" />

            <button
              mat-icon-button
              matSuffix
              [matMenuTriggerFor]="refinarMenu"
              type="button"
              aria-label="Refinar Busca"
              matTooltip="Refinar busca">
              <mat-icon>tune</mat-icon>
            </button>
            <mat-menu #refinarMenu="matMenu">
              <button mat-menu-item (click)="selecionarRefinamento(null)">
                @if (filtroRefinar === null) {
                  <mat-icon>check</mat-icon>
                }
                <span [class.ps-4]="filtroRefinar !== null">Número</span>
              </button>
              <button mat-menu-item (click)="selecionarRefinamento(_refinamentoEnum.cliente)">
                @if (filtroRefinar === _refinamentoEnum.cliente) {
                  <mat-icon>check</mat-icon>
                }
                <span [class.ps-4]="filtroRefinar !== _refinamentoEnum.cliente">Cliente</span>
              </button>
            </mat-menu>

            <button mat-icon-button matSuffix type="submit" aria-label="Pesquisar">
              <mat-icon>search</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <div class="col-12 col-md-6">
          <!-- Seletor de Periodo -->
          <button
            #periodoMenuTrigger="matMenuTrigger"
            mat-stroked-button
            type="button"
            class="btn-periodo margin-right-15"
            [matMenuTriggerFor]="periodoMenu"
            (menuOpened)="prepararPeriodoIntervalo()"
            [class.btn-periodo--ativo]="periodoSelecionado !== PeriodoEnum.SemFiltro">
            {{ periodoLabel }}
            <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
          </button>
          <mat-menu #periodoMenu="matMenu" class="periodo-custom-menu" (closed)="onPeriodoMenuClosed()">
            <div class="periodo-menu-content">
              <div>
                <button
                  type="button"
                  class="periodo-menu-item"
                  (click)="selecionarPeriodo(PeriodoEnum.SemFiltro); aplicarPeriodo()"
                  [class.periodo-item-selecionado]="periodoSelecionado === PeriodoEnum.SemFiltro">
                  <span>sem filtro</span>
                  @if (periodoSelecionado === PeriodoEnum.SemFiltro) {
                    <mat-icon>check</mat-icon>
                  }
                </button>
                <button
                  type="button"
                  class="periodo-menu-item"
                  (click)="selecionarPeriodo(PeriodoEnum.Ultimos30Dias); aplicarPeriodo()"
                  [class.periodo-item-selecionado]="periodoSelecionado === PeriodoEnum.Ultimos30Dias">
                  <span>últimos 30 dias</span>
                  @if (periodoSelecionado === PeriodoEnum.Ultimos30Dias) {
                    <mat-icon>check</mat-icon>
                  }
                </button>
                <button
                  type="button"
                  class="periodo-menu-item"
                  (click)="selecionarPeriodo(PeriodoEnum.DoMes); aplicarPeriodo()"
                  [class.periodo-item-selecionado]="periodoSelecionado === PeriodoEnum.DoMes">
                  <span>do mês</span>
                  @if (periodoSelecionado === PeriodoEnum.DoMes) {
                    <mat-icon>check</mat-icon>
                  }
                </button>
                <button
                  type="button"
                  class="periodo-menu-item"
                  (click)="selecionarPeriodo(PeriodoEnum.DoIntervalo); $event.stopPropagation()"
                  [class.periodo-item-selecionado]="periodoSelecionado === PeriodoEnum.DoIntervalo">
                  <span>do intervalo</span>
                  @if (periodoSelecionado === PeriodoEnum.DoIntervalo) {
                    <mat-icon>check</mat-icon>
                  }
                </button>

                @if (periodoSelecionado === PeriodoEnum.DoIntervalo) {
                  <div class="periodo-intervalo-fields" (click)="$event.stopPropagation()">
                    <mat-form-field appearance="outline">
                      <mat-label>De</mat-label>
                      <input
                        matInput
                        [matDatepicker]="pickerPeriodoDe"
                        #periodoDeModel="ngModel" inputmode="numeric" maxlength="10" placeholder="DD/MM/AAAA"
                        (keydown)="onDateKeydown($event)" (input)="onDateInput($event, periodoDeModel.control)"
                        [(ngModel)]="periodoIntervaloDe"
                        [ngModelOptions]="{ standalone: true }"
                        [max]="periodoIntervaloAte" />
                      <mat-datepicker-toggle matSuffix [for]="pickerPeriodoDe"></mat-datepicker-toggle>
                      <mat-datepicker #pickerPeriodoDe></mat-datepicker>
                      <mat-error>Informe uma data válida no formato DD/MM/AAAA</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>Até</mat-label>
                      <input
                        matInput
                        [matDatepicker]="pickerPeriodoAte"
                        #periodoAteModel="ngModel" inputmode="numeric" maxlength="10" placeholder="DD/MM/AAAA"
                        (keydown)="onDateKeydown($event)" (input)="onDateInput($event, periodoAteModel.control)"
                        [(ngModel)]="periodoIntervaloAte"
                        [ngModelOptions]="{ standalone: true }"
                        [min]="periodoIntervaloDe" />
                      <mat-datepicker-toggle matSuffix [for]="pickerPeriodoAte"></mat-datepicker-toggle>
                      <mat-datepicker #pickerPeriodoAte></mat-datepicker>
                      <mat-error>Informe uma data válida no formato DD/MM/AAAA</mat-error>
                    </mat-form-field>

                    <div class="periodo-intervalo-actions">
                      <button
                        type="button"
                        mat-button
                        class="btn-secondary"
                        (click)="cancelarPeriodoIntervalo(periodoMenuTrigger)">
                        Cancelar
                      </button>
                      <button
                        type="button"
                        mat-flat-button
                        class="btn-primary"
                        [disabled]="periodoDeModel.invalid || periodoAteModel.invalid"
                        (click)="aplicarPeriodo(periodoMenuTrigger)">
                        Aplicar
                      </button>
                    </div>
                  </div>
                }
              </div>
            </div>
          </mat-menu>

          <!-- Botao Filtrar -->
          <button
            mat-stroked-button
            type="button"
            class="btn-filter margin-right-15"
            [matMenuTriggerFor]="filtroMenu"
            (menuOpened)="prepararFiltrosAvancados()"
            [matBadge]="qtdFiltrosAvancados"
            matBadgeColor="warn"
            [matBadgeHidden]="qtdFiltrosAvancados === 0">
            <mat-icon>filter_list</mat-icon>
            Filtrar
          </button>
          <mat-menu #filtroMenu="matMenu" class="filter-custom-menu">
            <div class="filter-menu-content">
              <div (click)="$event.stopPropagation()">
                <h6>Filtros Avançados</h6>

                <div class="filter-menu__form">
                  <div class="filtro-row filtro-row-50-50">
                    <mat-form-field appearance="outline" class="filtro-col">
                      <mat-label>Tipo ambiente</mat-label>
                      <mat-select
                        [(ngModel)]="filtroIdTipoAmbienteDraft"
                        [ngModelOptions]="{ standalone: true }">
                        <mat-option [value]="null">Todos</mat-option>
                        <mat-option [value]="1">Produção</mat-option>
                        <mat-option [value]="2">Homologação</mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="filtro-col">
                      <mat-label>Status</mat-label>
                      <mat-select
                        [(ngModel)]="filtroIdStatusSecundarioDocumentoDraft"
                        [ngModelOptions]="{ standalone: true }">
                        <mat-option [value]="null">Todos</mat-option>
                        <mat-option [value]="1">Pendente</mat-option>
                        <mat-option [value]="5">Rejeitada</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div class="filtro-row filtro-row-90-10">
                    <mat-form-field appearance="outline" class="filtro-col">
                      <mat-label>Emissor</mat-label>
                      <mat-select [(ngModel)]="filtroIdEmissorDraft" [ngModelOptions]="{ standalone: true }">
                        <mat-option [value]="null">Todos</mat-option>
                        @for (emissor of emissores; track emissor.idEmissor) {
                          <mat-option [value]="emissor.idEmissor">{{ emissor.nome }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="filtro-col">
                      <mat-label>Série</mat-label>
                      <input
                        matInput
                        type="text"
                        [(ngModel)]="filtroSerieDraft"
                        (ngModelChange)="filtroSerieDraft = normalizarSerie($event)"
                        [ngModelOptions]="{ standalone: true }"
                        mask="000" [validation]="false"
                        maxlength="3"
                        inputmode="numeric"
                        pattern="[0-9]*"
                        placeholder="Ex: 1" />
                    </mat-form-field>
                  </div>


                </div>
              </div>

              <div class="filter-menu__actions">
                <button mat-button class="btn-secondary" (click)="cancelarFiltrosAvancados()" matMenuClose>
                  Cancelar
                </button>
                <button mat-flat-button class="btn-primary" (click)="aplicarFiltrosAvancados()" matMenuClose>
                  Aplicar
                </button>
              </div>
            </div>
          </mat-menu>

          <!-- Botao Limpar Filtros -->
          <button mat-stroked-button type="button" class="btn-filter" (click)="limparFiltros()">
            <mat-icon>cleaning_services</mat-icon>
            Limpar Filtros
          </button>
        </div>
      </div>
    </form>

    @if (_listaResponse && _dataSource.data.length > 0) {
      <!-- Tabela Desktop -->
      <table mat-table class="desktop-view" [dataSource]="_dataSource" matSort>
        <!-- Tipo ambiente -->
        <ng-container matColumnDef="tipoAmbiente">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo ambiente</th>
          <td mat-cell *matCellDef="let nota">
            @if (nota.tipoAmbiente === 1) {
              <div class="status-badge badge-verde">Produção</div>
            } @else if (nota.tipoAmbiente === 2) {
              <div class="status-badge badge-cinza">Homologação</div>
            } @else {
              <div class="status-badge badge-cinza">Desconhecido</div>
            }
          </td>
        </ng-container>

        <!-- NFC-E -->
        <ng-container matColumnDef="nfce">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>NFC-e</th>
          <td mat-cell *matCellDef="let nota">
            {{ nota.numero?.toString().padStart(8, '0') || '00000000' }}
          </td>
        </ng-container>

        <!-- Serie -->
        <ng-container matColumnDef="serie">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Série</th>
          <td mat-cell *matCellDef="let nota">
            {{
              nota.serie !== null && nota.serie !== undefined ? nota.serie.toString().padStart(3, '0') : ''
            }}
          </td>
        </ng-container>

        <!-- Emissor -->
        <ng-container matColumnDef="emissor">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Emissor</th>
          <td mat-cell *matCellDef="let nota">{{ nota.nomeEmissor || '-' }}</td>
        </ng-container>

        <!-- Data -->
        <ng-container matColumnDef="data">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Data/Hora Emissão</th>
          <td mat-cell *matCellDef="let nota">{{ nota.dataEmissao | date: 'dd/MM/yyyy HH:mm' }}</td>
        </ng-container>

        <!-- Cliente -->
        <ng-container matColumnDef="cliente">
          <th mat-header-cell *matHeaderCellDef>Cliente</th>
          <td mat-cell *matCellDef="let nota">
            <span class="truncate-cell" [matTooltip]="getClienteTooltip(nota)">{{
              getClienteDisplay(nota)
            }}</span>
          </td>
        </ng-container>

        <!-- Valor -->
        <ng-container matColumnDef="valor">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Valor</th>
          <td mat-cell *matCellDef="let nota" class="valor-cell">
            {{ nota.valorTotal | currency: 'BRL' : 'symbol' : '1.2-2' }}
          </td>
        </ng-container>

        <!-- Situacao -->
        <ng-container matColumnDef="situacao">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Situação</th>
          <td mat-cell *matCellDef="let nota">
            <div class="status-badge" [ngClass]="getSituacaoClass(nota)">
              {{ getSituacaoLabel(nota) }}
            </div>
          </td>
        </ng-container>

        <!-- Retorno SEFAZ -->
        <ng-container matColumnDef="retornoSefaz">
          <th mat-header-cell *matHeaderCellDef>Último Retorno SEFAZ</th>
          <td mat-cell *matCellDef="let nota">
            <span
              class="truncate-cell retorno-sefaz"
              [ngClass]="{ 'retorno-erro': nota.statusSecundarioDocumento === 5 }"
              [matTooltip]="getRetornoSefaz(nota)">
              {{ getRetornoSefaz(nota) }}
            </span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <!-- Cards Mobile -->
      <div class="mobile-view">
        @for (nota of _dataSource.data; track nota.idNFCeEmitido) {
          <div class="card">
            <div class="card-header">
              <div class="card-header-title">
                <strong>{{ getNumeroNFCe(nota) }}</strong>
                @if (nota.tipoAmbiente === 1) {
                  <div class="status-badge badge-verde">Produção</div>
                } @else if (nota.tipoAmbiente === 2) {
                  <div class="status-badge badge-cinza">Homologação</div>
                }
              </div>
              <div class="status-badge" [ngClass]="getSituacaoClass(nota)">{{ getSituacaoLabel(nota) }}</div>
            </div>
            <div class="card-body">
              <div class="card-row">
                <span class="card-label">Emissor</span>
                <span class="card-value">{{ nota.nomeEmissor || '-' }}</span>
              </div>
              <div class="card-row">
                <span class="card-label">Série</span>
                <span class="card-value">{{
                  nota.serie !== null && nota.serie !== undefined
                    ? nota.serie.toString().padStart(3, '0')
                    : ''
                }}</span>
              </div>
              <div class="card-row">
                <span class="card-label">Data/Hora</span>
                <span class="card-value">{{ nota.dataEmissao | date: 'dd/MM/yyyy HH:mm' }}</span>
              </div>
              <div class="card-row">
                <span class="card-label">Cliente</span>
                <span class="card-value card-truncate-cell">{{ getClienteDisplay(nota) }}</span>
              </div>
              <div class="card-row">
                <span class="card-label">Valor</span>
                <span class="card-value valor-cell">{{
                  nota.valorTotal | currency: 'BRL' : 'symbol' : '1.2-2'
                }}</span>
              </div>
              <div class="card-row">
                <span class="card-label">Retorno SEFAZ</span>
                <span class="card-value" [ngClass]="{ 'retorno-erro': nota.statusSecundarioDocumento === 5 }">
                  {{ getRetornoSefaz(nota) }}
                </span>
              </div>
            </div>
          </div>
        }
      </div>

      <div class="col-12 text-center mt-4 mb-5">
        <button mat-button [disabled]="_ultimaPagina" (click)="proximaPagina()">
          @if (_isLoading === true) {
            <mat-spinner [diameter]="20"></mat-spinner>
          } @else {
            <span class="material-symbols-outlined">expand_more</span>
            Ver mais
          }
        </button>
      </div>
    } @else if ((_isLoading === true || loadLookups === true) && _dataSource.data.length === 0) {
      <table class="w-100">
        @for (item of [1, 2, 3, 4, 5]; track item) {
          <tr>
            <td>
              <app-loading-box [height]="'23'" [width]="'80'" [marginTop]="'30'"></app-loading-box>
            </td>
            <td>
              <app-loading-box
                [height]="'23'"
                [width]="'100'"
                [marginTop]="'30'"
                [marginLeft]="'30'"></app-loading-box>
            </td>
            <td>
              <app-loading-box
                [height]="'23'"
                [width]="'50'"
                [marginTop]="'30'"
                [marginLeft]="'30'"></app-loading-box>
            </td>
            <td>
              <app-loading-box
                [height]="'23'"
                [width]="'120'"
                [marginTop]="'30'"
                [marginLeft]="'30'"></app-loading-box>
            </td>
            <td>
              <app-loading-box
                [height]="'23'"
                [width]="'90'"
                [marginTop]="'30'"
                [marginLeft]="'30'"></app-loading-box>
            </td>
            <td>
              <app-loading-box
                [height]="'23'"
                [width]="'80'"
                [marginTop]="'30'"
                [marginLeft]="'30'"></app-loading-box>
            </td>
            <td>
              <app-loading-box
                [height]="'23'"
                [width]="'70'"
                [marginTop]="'30'"
                [marginLeft]="'30'"></app-loading-box>
            </td>
            <td>
              <app-loading-box
                [height]="'23'"
                [width]="'60'"
                [marginTop]="'30'"
                [marginLeft]="'30'"></app-loading-box>
            </td>
            <td>
              <app-loading-box
                [height]="'23'"
                [width]="'150'"
                [marginTop]="'30'"
                [marginLeft]="'30'"></app-loading-box>
            </td>
          </tr>
        }
      </table>
    } @else {
      <app-empty-list
        title="Nenhuma nota em contingência encontrada"
        subTitle="Tente alterar os filtros para encontrar resultados."></app-empty-list>
    }
  </div>
</div>
